// extracted by mini-css-extract-plugin
module.exports = {"toast_body":"styles_toast_body__2RB1K","title":"styles_title__1NPz4","content":"styles_content__3ZRtT","link":"styles_link__2MWA1","button":"styles_button__3eR74"};